import { PricingTierSchema } from '@/api/generated'

export const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return '-'
  return date.toLocaleDateString('en-US', { timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric' })
}

export const formatPrice = (cents?: number | null) => {
  if (cents === null || cents === undefined) return '-'
  return `$${(cents / 100).toFixed(2)}`
}

export const formatPricing = (
  pricingTiers?: PricingTierSchema[] | null,
  customUnitPriceCents?: number | null,
) => {
  if (pricingTiers && pricingTiers.length > 0) {
    return `${pricingTiers.length} tier${pricingTiers.length !== 1 ? 's' : ''}`
  }
  return formatPrice(customUnitPriceCents)
}
